<template>
  <div class="ion-page">
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-icon size="large" :src="icon" :style="color" class="header-icon-start" />
        </ion-buttons>
        <ion-title :id="title">{{ title }}</ion-title>
        <ion-buttons slot="end">
          <ion-icon size="large" name="arrow-back" class="header-icon-end" @click="goToHome" />
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-row class="mb1">
        <b class="mr10">Solicitar cita para el:</b>
        {{ dateFormatted }}
      </ion-row>
      <ion-row class="mb1">
        Nos pondremos en contacto con usted, a la mayor brevedad posible, para
        confirmar la cita.
      </ion-row>
      <ion-list lines="full" class="ion-no-margin ion-no-padding">
        <ion-item>
          <ion-label position="floating">
            <sup>*</sup> Nombre
          </ion-label>
          <ion-input
            name="firstName"
            class="is_invalid"
            @ionInput="
              firstName = $event.target.value
              validateValue($event.target)
            "
            @ionChange="changeButtonTextAndColor()"
          />
        </ion-item>
        <ion-item>
          <ion-label position="floating">
            <sup>*</sup> Apellidos
          </ion-label>
          <ion-input
            name="lastName"
            class="is_invalid"
            @ionInput="
              lastName = $event.target.value
              validateValue($event.target)
            "
            @ionChange="changeButtonTextAndColor()"
          />
        </ion-item>
        <ion-item>
          <ion-label position="floating">
            <sup>*</sup> Teléfono
          </ion-label>
          <ion-input
            name="phone"
            inputmode="tel"
            maxlength="9"
            class="is_invalid"
            :value="phone"
            @ionInput="phone = $event.target.value"
            @ionChange="
              changeButtonTextAndColor()
              validatePhone($event.target)
            "
          />
        </ion-item>
        <ion-item>
          <ion-label position="floating">Comentarios</ion-label>
          <ion-textarea class="is_valid" @ionInput="comments = $event.target.value"></ion-textarea>
        </ion-item>
      </ion-list>
      <ion-item>
        <ion-label position="floating">
          <sup>*</sup> Compañía
        </ion-label>
        <ion-select
          class="is_invalid"
          placeholder="Selecciona una"
          ok-text="Confirmar"
          cancel-text="Cancelar"
          @ionChange="
            company = $event.target.value
            changeButtonTextAndColor()
            validateValue($event.target)
          "
        >
        <!-- <ion-select-option *ngIf="title == 'Medicina general'">"Particulares"</ion-select-option> -->
          <ion-select-option
            v-for="(company, index) in companyList"
            :value="company.name"
            v-bind:key="index"
          >{{ company.name }}</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item>
        <ion-label position="floating">
          <sup>*</sup> Prioridad
        </ion-label>
        <ion-select
          class="is_invalid"
          placeholder="Selecciona una"
          ok-text="Confirmar"
          cancel-text="Cancelar"
          @ionChange="
            priority = $event.target.value
            changeButtonTextAndColor()
            validateValue($event.target)
          "
        >
          <ion-select-option value="Primera visita">Primera visita</ion-select-option>
          <ion-select-option value="Urgente">Urgente</ion-select-option>
          <ion-select-option value="Revisión">Revisión</ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item>
        <ion-label position="floating">
          <sup>*</sup> Sede
        </ion-label>
        <ion-select
          :class="location ? 'is_valid' : 'is_invalid'"
          placeholder="Selecciona una"
          ok-text="Confirmar"
          cancel-text="Cancelar"
          :value="location"
          @ionChange="
            location = $event.target.value
            changeButtonTextAndColor()
          "
        >
          <ion-select-option
            v-for="(location, index) in locations"
            :value="location.id"
            v-bind:key="index"
          >{{ location.name }}</ion-select-option>
        </ion-select>
      </ion-item>
      <div class="privacy_policy">
        <ion-checkbox
          id="privacy_policy"
          @ionChange="
            privacy_policy = $event.target.checked
            changeButtonTextAndColor()
          "
          color="success"
        ></ion-checkbox>Acepto la
        <a
          href="https://cardiavant.com/politica-de-privacidad/"
          target="_blank"
        >política de privacidad</a>
      </div>
      <div class="ion-padding">
        <ion-button
          class="mt3"
          :color="buttonColor"
          :disabled="disabled"
          expand="block"
          @click="processForm()"
        >{{ buttonText }}</ion-button>
      </div>
    </ion-content>
    <ion-alert-controller />
    <ion-toast-controller />
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

export default {
  name: 'Schedule',
  data() {
    return {
      title: '',
      color: '',
      icon: '',
      description: '',
      selectedDate: '',
      dateFormatted: '',
      firstName: '',
      lastName: '',
      phone: '',
      company: '',
      priority: '',
      location: '',
      comments: '',
      companyList: [],
      disabled: true,
      privacy_policy: false,
      buttonText: 'Rellene los campos obligatorios',
      buttonColor: 'danger',
      locations: [],
    }
  },
  mounted() {
    if (localStorage.params) {
      const params = JSON.parse(localStorage.params)
      this.title = params.title
      this.icon = params.icon
      this.color = params.color
      this.description = params.description
      this.selectedDate = this.fotmatDate(params.date)
      this.dateFormatted = params.dateFormatted
      this.locations = params.locations
      if (this.locations.length === 1) this.location = this.locations[0].id
    }
    this.getAuthTokenFromFilemakerServer('get')
  },
  methods: {
    goToHome() {
      this.$router.push('detail')
    },
    fotmatDate(date) {
      return date.month + '-' + date.day + '-' + date.year
    },
    validateValue(target) {
      if (target.value.length > 1) {
        target.classList.remove('is_invalid')
        target.classList.add('is_valid')
      } else {
        target.classList.remove('is_valid')
        target.classList.add('is_invalid')
      }
    },
    validatePhone(target) {
      this.phone = this.phone.replace(/\D+/g, '')
      if (target.value.length === 9) {
        target.classList.remove('is_invalid')
        target.classList.add('is_valid')
      } else {
        target.classList.remove('is_valid')
        target.classList.add('is_invalid')
      }
    },
    changeButtonTextAndColor() {
      if (
        this.firstName !== '' &&
        this.lastName !== '' &&
        this.phone !== '' &&
        this.phone.length === 9 &&
        this.priority !== '' &&
        this.company !== '' &&
        this.location !== '' &&
        this.privacy_policy === true
      ) {
        this.buttonText = 'Solicitar cita'
        this.buttonColor = 'success'
        this.disabled = false
      } else {
        this.buttonText = 'Rellene los campos obligatorios'
        this.buttonColor = 'danger'
        this.disabled = true
      }
    },
    processForm() {
      if (
        this.firstName === '' ||
        this.lastName === '' ||
        this.phone === '' ||
        this.phone.length !== 9 ||
        this.company === '' ||
        this.priority === '' ||
        this.location === ''
      ) {
        this.presentResultMessage(
          'Error',
          '',
          'danger',
          'Rellene todos los campos obligatorios.',
        )
        return false
      }

      if (this.privacy_policy === false) {
        this.presentResultMessage(
          'Error',
          '',
          'danger',
          'Debe aceptar la política de privacidad',
        )
        return false
      }

      this.getAuthTokenFromFilemakerServer('send')
    },
    getAuthTokenFromFilemakerServer(action) {
      axios({
        method: 'get',
        url: 'api/public/',
      })
        .then((response) => {
          if (action === 'send') {
            this.sendRequestToFilemakerServer(response.data.response.token)
          } else {
            this.getCompanyList(response.data.response.token)
          }
        })
        .catch((error) => {
          this.presentResultMessage(
            'Error',
            '',
            'danger',
            'Ha ocurrido un error la conexión con el servidor, pruebe de nuevo.',
          )
        })
    },
    getCompanyList(authToken) {
      axios({
        method: 'post',
        url: 'api/public/companies',
        headers: {
          'Content-Type': 'application/json',
          'X-Auth-Token': authToken,
        },
        data: {
          query: [
            {
              VerEnWeb: 'SI',
            },
          ],
          sort: [
            {
              fieldName: 'Nombre',
              sortOrder: 'ascend',
            },
          ],
        },
      })
        .then((response) => {
          let items = response.data.response.data
          for (let i = 0; i < items.length; i++) {
            this.companyList.push({
              id: items[i].fieldData.ClavePrincipal,
              name: items[i].fieldData.Nombre,
            })
          }
        })
        .catch((error) => {
          this.presentResultMessage(
            'Error',
            '',
            'danger',
            'No se ha podido generar el desplegable con las compañías, pruebe de nuevo.',
          )
        })
    },
    sendRequestToFilemakerServer(authToken) {
      axios({
        method: 'post',
        url: 'api/public/appointment',
        headers: {
          'Content-Type': 'application/json',
          'X-Auth-Token': authToken,
        },
        data: {
          fieldData: {
            Fecha: this.selectedDate,
            Especialidad: this.title,
            Nombre: this.firstName,
            Apellidos: this.lastName,
            Telefono: this.phone,
            Mutua: this.company,
            Prioridad: this.priority,
            Comentarios: this.comments,
            Sede: this.location,
            Ubicada: 'No',
          },
        },
      })
        .then((response) => {
          this.presentResultMessage(
            'Gracias',
            'La cita se ha solicitado correctamente.',
            'success',
            'Nos pondremos en contacto con usted a la mayor brevedad para confirmarle la fecha y la hora de la cita.',
          )
          this.disabled = true
          setTimeout(() => {
            location.href = 'https://cardiavant.com/gracias-por-el-mensaje/'
          }, 2000)
        })
        .catch((error) => {
          this.presentResultMessage(
            'Error',
            '',
            'danger',
            'Ha ocurrido un error al crear la cita, pruebe de nuevo.',
          )
        })
    },
    presentResultMessage(header, subHeader, color, message) {
      const error = document.querySelector('ion-toast-controller')
      error
        .create({
          header,
          subHeader,
          color,
          message,
          showCloseButton: true,
          closeButtonText: 'Cerrar',
        })
        .then((toast) => toast.present())
    },
  },
}
</script>

<style scoped>
ion-toolbar {
  --background: #ededed;
  height: 94px;
}

ion-header ion-toolbar:first-child {
  padding-top: 15px;
}

ion-input.is_invalid,
ion-select.is_invalid {
  color: #d33939;
}

ion-input.is_valid,
ion-select.is_valid,
ion-textarea.is_valid {
  color: #04a543;
}

.header-icon-start {
  margin: 19px 15px 18px;
}

.header-icon-end {
  margin-right: 20px;
  color: #4d206a;
}

sup {
  color: #d33939;
}

.mt3 {
  margin-top: 3em;
}

.mb1 {
  margin-bottom: 1em;
}

.mr10 {
  margin-right: 10px;
}

.privacy_policy {
  margin-top: 15px;
  margin-left: 15px;
}

ion-checkbox {
  margin-right: 15px;
}
</style>
